var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpisode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M15.625 20.833h2.083a2.083 2.083 0 0 0 0-4.166h-2.083a2.083 2.083 0 0 0 0 4.166zm8.333 12.5h-8.333a2.083 2.083 0 0 0 0 4.167h8.333a2.083 2.083 0 0 0 0-4.167zm0-8.333h-8.333a2.083 2.083 0 0 0 0 4.167h8.333a2.083 2.083 0 0 0 0-4.167zm14.417-5.458a2.083 2.083 0 0 0-.438-2.271l-12.5-12.5a2.229 2.229 0 0 0-.583-.396.667.667 0 0 0-.187 0l-.584-.208H11.458a6.25 6.25 0 0 0-6.25 6.25v29.166a6.25 6.25 0 0 0 6.25 6.25h12.5a2.083 2.083 0 0 0 0-4.166h-12.5a2.083 2.083 0 0 1-2.083-2.084V10.417a2.083 2.083 0 0 1 2.083-2.084h10.417v6.25a6.25 6.25 0 0 0 6.25 6.25h8.333a2.084 2.084 0 0 0 1.917-1.291zm-10.25-2.875a2.083 2.083 0 0 1-2.083-2.084v-3.312l5.396 5.396zM42.708 25H32.292a2.083 2.083 0 0 0-2.084 2.083V43.75a2.083 2.083 0 0 0 1.105 1.833 2.083 2.083 0 0 0 2.083-.104l4.104-2.708 4.167 2.708a2.083 2.083 0 0 0 3.125-1.729V27.083A2.083 2.083 0 0 0 42.708 25zm-2.083 14.833-1.958-1.312a2.083 2.083 0 0 0-2.334 0l-1.958 1.312V29.167h6.25z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisode);
export default __webpack_public_path__ + "static/media/episode.d150d1632e5972b1173c2ad0a4ff6365.svg";
export { ForwardRef as ReactComponent };